import * as React from 'react';
import { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import ReusableDiv from 'src/support/ReusableDiv';
import Cart from "@system/config/cart";

const LeavingCheckout = (props) => {
    const [status, SetStatus] = useState(false);
    const quoteNumber = props.data.quoteNumber;

    useEffect(() => {
        SetStatus(true)
    }, []);

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const onContinue = async () => {
        let url = Cart.getCartPageRouteURL();
        if (quoteNumber)
            url = `${Cart.getQuoteCartPageRouteURL()}?quote_number=${quoteNumber}`;

        window.location.href = url;
        onHide()
    };

    return (
        <Modal show={status} onHide={() => { onHide() }}>
            <div className="avnet-modal modal-730">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => { onHide() }}>×</button>
                    {ReusableDiv.PopupTitle("Leaving Page?")}
                    <div className="modal-body">
                        <p className="text-center">Click "Continue" to leave Checkout and return to Cart.</p>
                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <button type="button" className="bs5 btn btn-secondary"
                            onClick={() => { onHide() }}>Cancel</button>
                        <button type="button" className="bs5 btn btn-primary"
                            onClick={() => { onContinue() }}>Continue</button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default LeavingCheckout;